// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@flip/App/Components/Common/XngZone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

export interface RequestQuotePageStyles {}

const requestQuotePageStyles: RequestQuotePageStyles = {};

type Props = PageProps;

const styles = requestQuotePageStyles;
const RequestQuotePage: React.FunctionComponent<Props> = ({ id }: Props) => {
    return (
        <Page data-test-selector="request-quote">
            <XngZone contentId={id} zoneName="Request Quote Form" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: RequestQuotePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
